module.exports = __webpack_public_path__ + "static/media/07.ae12cd62.jpg";